import clsx from 'clsx';
import { type ReactNode, useRef } from 'react';
import { useDrag } from 'react-dnd';

import { AnnotationDragDescriptor, ANNOTATIONS_MARKER } from './AnnotationUtils';
import styles from './DragStyles.css';

type MarkerDragSourceProps = {
  id: number;
  left: number;
  top: number;
  canDrag: boolean;
  children: ReactNode;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  onClick?: () => void;
  focus: boolean;
  blur: boolean;
};

export default function MarkerDragSource({
  id,
  canDrag,
  left,
  top,
  children,
  onMouseOver,
  onMouseOut,
  onClick,
  focus,
  blur,
}: MarkerDragSourceProps) {
  // Drag handler
  const refDrag = useRef<HTMLDivElement>(null);
  const [{ isDragging }, dragConnector] = useDrag<AnnotationDragDescriptor, unknown, { isDragging: boolean }>({
    type: ANNOTATIONS_MARKER,
    item: () => ({ id, left, top }),
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: () => canDrag,
  });
  dragConnector(refDrag);

  return (
    <div
      ref={refDrag}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={onClick}
      className={clsx(styles.dragSource, focus && styles.focused, blur && styles.blurred)}
      style={{
        top: `${top}%`,
        left: `${left}%`,
        cursor: canDrag ? (isDragging ? 'grabbing' : 'grab') : 'pointer',
      }}
    >
      {children}
    </div>
  );
}
